import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'src/constants';
import ApiService from 'src/modules/api-service';
import { BidVisibility, SummaryRequestDTO } from 'src/modules/generated/api';
import { bidVisibilityLocalStorageKey } from 'src/modules/global-vars';

type UseFilterSummaryProps = {
  summaryState: SummaryRequestDTO;
};

export const useFilterSummary = ({ summaryState }: UseFilterSummaryProps) => {
  const state = {
    ...summaryState,
  };
  // @ts-ignore validity fallback "" causes problems in summary api
  if (summaryState.validity === '') delete state.validity;
  return useQuery(
    [QueryKeys.filterSummary, summaryState],
    () => ApiService.listCars.listCarsControllerSummaryPost(state, 2).then((res) => res.data),
    {
      keepPreviousData: true,
      staleTime: 60 * 1000,
      // 1 minute
    },
  );
};

export const useBidsFilterSummary = ({ summaryState }: UseFilterSummaryProps) => {
  const stateCopy = { ...summaryState };
  const visibility = localStorage.getItem(bidVisibilityLocalStorageKey) || 'false';
  // workaround for the issue with the visibility filter
  switch (visibility) {
    case BidVisibility.All:
      stateCopy.bidCreatorDealerCountry = undefined;
      stateCopy.bidCreatorDealerId = undefined;
      stateCopy.bidCreatorUserId = undefined;
      break;
    case BidVisibility.Dealer:
      stateCopy.bidCreatorDealerCountry = undefined;
      stateCopy.bidCreatorUserId = undefined;
      break;
    case BidVisibility.User:
      stateCopy.bidCreatorDealerCountry = undefined;
      stateCopy.bidCreatorDealerId = undefined;
      break;
    case BidVisibility.Country:
      stateCopy.bidCreatorDealerId = undefined;
      stateCopy.bidCreatorUserId = undefined;
      break;
    case 'false':
    default:
      break;
  }

  return useQuery(
    [QueryKeys.bidsFilterSummary, summaryState, stateCopy],

    () => ApiService.bids.bidControllerSummaryPost(stateCopy).then((res) => res.data),
    {
      keepPreviousData: true,
      staleTime: 60 * 1000,
      // 1 minute
    },
  );
};
